import { createFileRoute } from "@tanstack/react-router";
import LongTermRelationshipBreakup from "@/pages/articles/LongTermRelationshipBreakup";
export const Route = createFileRoute(
  "/ending-a-long-term-relationship-in-your-30s-and-40s",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Breakups in Your 30s & 40s | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Breakups in midlife hit differently. Learn how to cope with depression after a long-term relationship ends, and treatment options in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Breakups in Your 30s & 40s | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Breakups in midlife hit differently. Learn how to cope with depression after a long-term relationship ends, and treatment options in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/ending-a-long-term-relationship-in-your-30s-and-40s",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ending-a-long-term-relationship-in-your-30s-and-40s",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <LongTermRelationshipBreakup />;
}
